import { useLocation } from "react-router-dom";
import { useChat as useChatFromChatContext } from "../providers/chatContext";
import { useChat as useChatFromV2ChatContext } from "../providers/v2ChatContext";
import { ROUTES } from "../constants";

const useChat = () => {
  const location = useLocation();

  // Always call both hooks to avoid conditional hook calls
  const chatContextValue = useChatFromChatContext();
  const v2ChatContextValue = useChatFromV2ChatContext();

  const v2ContextRoutes = [ROUTES.v2, ROUTES.sms, ROUTES.web, ROUTES.whatsapp];
  const shouldUseV2Context = v2ContextRoutes.some((route) =>
    location.pathname.startsWith(`/${route}`)
  );

  // Return the appropriate context value based on the route
  return shouldUseV2Context ? v2ChatContextValue : chatContextValue;
};

export default useChat;
